export default __webpack_public_path__ + "static/media/reportar.6af8c53e.svg";